module.exports = __webpack_public_path__ + "img/demo-01-slide-3.15f4c4a9.jpg";